export const formatPrice = (price?: number) => (price ? `${new Intl.NumberFormat('ru-RU').format(price)} ₽` : '-');
